import React ,{Component} from 'react';
import { css } from 'emotion';

export default class ImageCard extends Component {
  constructor(props) {
    super(props);
  }

  //    <div className="Logo" itemScope itemstype="http://schema.org/ImageObject">

  render() {
    const  {image,animate,offset,className,whichAnimation,triggerAnchor,assignId} = this.props;
    let renderAnimation = whichAnimation;
    if(!renderAnimation)
       renderAnimation = "fad-out";

    let classToUse = className;
    if(!classToUse)
      classToUse = css`${iconImageStyleProd}`;

    if(animate){
      //className={className}
       return (
           <img id={assignId} 
                data-aos={renderAnimation} 
                data-aos-anchor={triggerAnchor} 
                data-aos-offset={offset}  
                data-aos-anchor-placement="top-top" 
                src={image} 
                className={classToUse}
                />
         );
     }
     else {
       return (
           <img id={assignId} src={image} className={classToUse} />
       );
     }
  }
}

const iconImageStyleProd = {
  width: '30px',   
  margin: '0px 10px 7px 0px',
};